import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpAnonymousTicketService } from '../../service/http-anonymous-ticket-service.service';
import { TicketStatusDto } from '../../service/dto';

@Component({
	selector: 'app-ticket-status-anonymous',
	standalone: false,
	templateUrl: './ticket-status-anonymous.component.html',
	styleUrls: ['./ticket-status-anonymous.component.scss']
})
export class TicketStatusAnonymousComponent implements OnInit {
	ticketReference!: string;
	ticketStatus?: TicketStatusDto;
	loading = true;
	error?: string;

	constructor(private route: ActivatedRoute, private httpService: HttpAnonymousTicketService) { }

	ngOnInit(): void {
		this.route.paramMap.subscribe(params => {
			const ref = params.get('ticketReference');
			if (ref) {
				this.ticketReference = ref;
				this.loadStatus();
			} else {
				this.loading = false;
				this.error = 'Invalid ticket reference.';
			}
		});
	}

	private loadStatus(): void {
		this.loading = true;
		this.error = undefined;
		this.httpService.getStatus(this.ticketReference).subscribe({
			next: (data) => {
				if (!data) {
					// Empty 200 OK response (null/undefined body)
					this.error = 'Ticket not found or no data available.';
					this.ticketStatus = undefined;
				} else {
					this.ticketStatus = data;
				}
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
				this.error = 'Failed to load ticket status.';
				console.error(err);
			}
		});
	}
}
